import { aircraftDetailQuery } from "@common/api/aircraft"
import { Card } from "@common/components/ui/card"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { AircraftForm } from "@/routes/_layout/aircraft/-components/form/aircraft-form"

export const Route = createFileRoute("/_layout/aircraft_/$aircraftId_/edit")({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "aircraft:update", "/"),
  loader: async ({ context: { queryClient }, params: { aircraftId } }) => {
    const aircraft = await queryClient.ensureQueryData(
      aircraftDetailQuery({ id: aircraftId }),
    )
    return {
      breadcrumb: [
        { label: "Aircraft", href: "/aircraft" },
        { label: aircraft.registration_no, href: `/aircraft/${aircraftId}` },
        { label: "Edit" },
      ],
    }
  },
  component: EditAircraftPage,
})

function EditAircraftPage(): React.ReactElement {
  const { aircraftId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const { data: aircraft } = useSuspenseQuery(
    aircraftDetailQuery({ id: aircraftId }),
  )
  const close = () =>
    navigate({ to: "/aircraft/$aircraftId", params: { aircraftId } })

  return (
    <div className="h-full overflow-y-auto">
      <PageContent>
        <PageTitle title={`Edit ${aircraft.registration_no}`} />
        <Card className="p-4 shadow-none">
          <AircraftForm
            aircraft={aircraft}
            onSaved={(updated) => {
              showToast(
                "Saved",
                `${updated.registration_no} updated.`,
                "success",
              )
              close()
            }}
            onCancel={close}
          />
        </Card>
      </PageContent>
    </div>
  )
}
